<mrf-form [form]="formJson" [config]="formSubmit"></mrf-form>

<button mat-stroked-button  color='basic' class="pers2 mleft" (click)="modificaLista()">
    MODIFICA
</button>

<button mat-stroked-button  color='basic' class="pers2 mleft" (click)="salva()">
    SALVA
</button>

<button mat-stroked-button  color='basic' class="pers2 mleft" (click)="setta()">
    SETTA
</button>